<template>
    <div>
        <div class="tpl-portlet-components" ref="getWidth" >
            <div class="tpl-portlet-title">
                <div class="tpl-caption font-blue">
                    <div style="float: left;margin-left:120px">
                        <button id="currentMonth" class="view-btn data-btn btn-gradient" v-on:click="selectCurrent">本月
                        </button>
                        <div id="plan-calendar-time-year" class="select-wrap">
                            <el-date-picker
                                    v-model="selectDate"
                                    type="month"
                                    placeholder="选择月"
                                    @change="selectMonth"
                            >
                            </el-date-picker>
                        </div>
                    </div>
                </div>
                <div class="tpl-caption" style="margin-top: 10px;display: none" >
                    <a style="font-size: 12px">导入规划</a>
                </div>
            </div>
            <div class="outer_month_plans_div">
                <swiper class="swiper" :options="swiperOption" ref="mySwiper">
                    <swiper-slide v-for="(month,index) in monthList"
                                  :key="index">
                        <MonthCard :data="month"></MonthCard>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
    import MonthCard from '@/apps/plan/sub_components/cards/month_card.vue'
    import {Swiper, SwiperSlide} from 'vue-awesome-swiper'
    import {mapState, mapGetters, mapActions} from 'vuex'
    import 'swiper/css/swiper.css'
    import skillApi from '@/api/skill/skill.js'

    export default {
        name: "month_view",
        components: {
            MonthCard,
            Swiper,
            SwiperSlide
        },
       props: {
        ViewSize: {
            default: 2,
            type: Number
        }
    },
        data: function () {
            return {
                swiperOption: {
                    slidesPerView:this.ViewSize,
                    spaceBetween: 10,
                    slidesPerGroup: 1,
                    loop: true,
                    loopFillGroupWithBlank: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    on: {
                        init: function () {
                            let dd = new Date();
                            this.slideTo(dd.getMonth() + 2, 0);
                        },
                    }
                },
                isOwner:true,
                selectDate: new Date(),
                monthList: [
                    {
                        "year": (new Date()).getFullYear(),
                        "month": "1"
                    },
                    {
                        "year": (new Date()).getFullYear(),
                        "month": "2"
                    },
                    {
                        "year": (new Date()).getFullYear(),
                        "month": "3"
                    },
                    {
                        "year": (new Date()).getFullYear(),
                        "month": "4"
                    },
                    {
                        "year": (new Date()).getFullYear(),
                        "month": "5"
                    },
                    {
                        "year": (new Date()).getFullYear(),
                        "month": "6"
                    },
                    {
                        "year": (new Date()).getFullYear(),
                        "month": "7"
                    },
                    {
                        "year": (new Date()).getFullYear(),
                        "month": "8"
                    },
                    {
                        "year": (new Date()).getFullYear(),
                        "month": "9"
                    },
                    {
                        "year": (new Date()).getFullYear(),
                        "month": "10"
                    },
                    {
                        "year": (new Date()).getFullYear(),
                        "month": "11"
                    },
                    {
                        "year": (new Date()).getFullYear(),
                        "month": "12"
                    }]
            }
        },
        methods: {
            ...mapActions({
                get_my_plans: 'plan/get_my_plans',
                get_plans_by_user:'plan/get_plans_by_user',
                change_display_plans_params: 'plan/change_display_plans_params',
            }),
            selectMonth: function (val) {
                let newDate = new Date(val);
                this.monthList.forEach((item) => {
                    item.year = newDate.getFullYear();
                })
                this.toSlide(newDate.getMonth() + 2);
                this.change_display_plans_params({
                    'date': newDate,
                    'type': 'month'
                })
            },
            selectCurrent: function () {
                let newDate = new Date();
                this.monthList.forEach((item) => {
                    item.year = newDate.getFullYear();
                });
                this.selectDate = newDate;
                this.toSlide(newDate.getMonth() + 2);
                this.change_display_plans_params({
                    'date': newDate,
                    'type': 'month'
                })
            },
            toSlide(index) {
                this.$refs.mySwiper.$swiper.slideTo(index, 0)
            },
        },
        computed: {
            ...mapState({
                   login_user_id: state => state.loginState.user_info.id,
                display_plans_params: state => state.plan.display_plans_params,
            }),
            ...mapGetters({
               display_plans: 'plan/display_plans',
            }),
        },
        created(){

        },
        mounted() {
            skillApi.get_my_skill_targets().then((res) => {
                console.log(res.data)
            })
            let uid=this.$route.query.uid;
             if(uid) {
               this.get_plans_by_user(uid)
                 if(uid!=this.login_user_id){
                     this.isOwner=false;
                 }
             }
             else{
                this.get_my_plans()
             }
        }
    }
</script>

<style scoped>

    swiper-content {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
        margin: 0 auto;
        padding: 50px 0;
    }

    .view-btn {
        padding: 0;
        text-align: center;
        cursor: pointer;
        border: 1px solid #e1e1e1;
    }

    .data-btn {
        position: relative;
        border-radius: 3px;
        font-size: 12px;
        height: 28px;
        width: 49px;
        margin-left: 20px;
        margin-right: 10px;
        background-color: #fff;
        border: 1px solid #d7d8d9;
        z-index: 23 \0;
    }

    div.select-wrap {
        vertical-align: middle;
        background-color: #fff;
        margin-right: 10px;
        color: #000;
        display: inline-block;
        cursor: pointer;
    }

</style>